import { observer } from "mobx-react-lite";
import React from "react";
import { useStores } from "_common/hooks";

import loading from "assets/img/loading.gif";

const PageLoading = observer(() => {
  const { authStore } = useStores();

  return (
    <div className="page-loading">
      <div className="bg-inner" />
      <img className="loading-img" src={loading} alt="logo" />
    </div>
  );
});

export default PageLoading;
